import { render, staticRenderFns } from "./AsignacionesMenu.vue?vue&type=template&id=93c40066&scoped=true"
import script from "./AsignacionesMenu.vue?vue&type=script&lang=js"
export * from "./AsignacionesMenu.vue?vue&type=script&lang=js"
import style0 from "./AsignacionesMenu.vue?vue&type=style&index=0&id=93c40066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c40066",
  null
  
)

export default component.exports